import AboutSerious from "./AboutSerious"

export default AboutSerious